import classNames from 'classnames';
import React, { useState } from 'react';
import useEventListener from '../../utils/useEventListener';
import { useQuill } from '../QuillContext';
import useInternalCopyPaste from '../utils/useInternalCopyPaste';
import styles from './ImageCaption.module.scss';

const LINE_BREAK_REGEX = /\r?\n|\r/g;
const PLACEHOLDER = 'Add a caption';

interface ImageCaptionProps {
  caption: string;
  onCaptionChange: (caption: string) => void;
}

const ImageCaption = ({ caption, onCaptionChange }: ImageCaptionProps) => {
  const { readOnly } = useQuill();
  const [textareaNode, setTextareaNode] = useState<HTMLTextAreaElement | null>(
    null,
  );

  const setElement = useInternalCopyPaste();

  useEventListener(textareaNode, 'keydown', (event) => {
    // Let Quill handle these keys
    if (!['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
      event.stopPropagation();
    }
  });

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) =>
    onCaptionChange(event.target.value.replace(LINE_BREAK_REGEX, ' '));

  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const showTextarea = !readOnly;
  return (
    <div
      ref={setElement}
      className={classNames(styles.captionContainer, {
        [styles.empty]: !caption,
      })}
    >
      <figcaption
        className={classNames(styles.caption, { [styles.hide]: showTextarea })}
      >
        {caption || (showTextarea ? PLACEHOLDER : '')}
      </figcaption>
      {showTextarea && (
        <textarea
          ref={setTextareaNode}
          className={styles.caption}
          value={caption}
          placeholder={PLACEHOLDER}
          onChange={handleChange}
        />
      )}
    </div>
  );
};

export default ImageCaption;
